import { ChangeEvent, FC, useEffect, useState } from 'react';
import { Buttons } from '../../../common/TwoButtonModal/TwoButtonModal.styles';
import Button from '../../../components/Button/Button';
import { Variant } from '../../../components/Button/Button.types';
import Dropdown from '../../../components/Dropdown/Dropdown';
import Modal from '../../../components/Modal/Modal';
import { showToast } from '../../../components/Toast/Toast';
import { useExtractManInvGroup } from '../../../services/extract/extract.service';
import { useGenericErrorMessage } from '../../../utils/useGenericErrorMessage/useGenericErrorMessage';
import { DropdownWrapper, Message } from './ManInvExtractModal.styles';
import { ManInvExtractModalProps } from './ManInvExtractModal.types';

const ManInvExtractModal: FC<ManInvExtractModalProps> = ({
  open,
  onClose,
  options,
  setToggleDataSource,
  toggleDataSource,
}) => {
  const [selectedManInvId, setSelectedManInvId] = useState<string | undefined>(undefined);
  const { mutate: extractManInvRequest, isError, isLoading, error } = useExtractManInvGroup();

  // close the modal and show an error toast if error fetching or extracting
  useGenericErrorMessage([{ isError, error }]);

  // reset dropdown when modal closes
  useEffect(() => {
    if (!open) {
      setSelectedManInvId(undefined);
    }
  }, [open]);

  const handleManInvSelect = (event: ChangeEvent<HTMLSelectElement>) => {
    setSelectedManInvId(event.target.value);
  };

  const extractManInv = () => {
    if (selectedManInvId) {
      extractManInvRequest(+selectedManInvId, {
        onSuccess: () => {
          setToggleDataSource(!toggleDataSource);
          onClose();
          showToast({
            id: 'extractManInvSuccess',
            label: 'Mandatory Inventory Group Extract Request was successfully submitted',
          });
        },
      });
    }
  };

  return (
    <Modal title='Mandatory Inventory Extract' id='manInvExtract' open={open} onClose={onClose}>
      <div>
        <Message>Select Mandatory Inventory group to extract</Message>
        <DropdownWrapper>
          <Dropdown
            value={selectedManInvId}
            label='Mandatory Inventory Group'
            id='selectManInvGroupToExtract'
            dataTestId='selectManInvGroupToExtractDropdown'
            options={options}
            onChange={handleManInvSelect}
          />
        </DropdownWrapper>
        <Buttons>
          <Button label='Cancel' testId='cancelExtractManInvModalButton' onClick={onClose} variant={Variant.Secondary} />
          <Button
            label='Extract'
            onClick={extractManInv}
            testId='extractManInvModalButton'
            disabled={selectedManInvId === undefined}
            isLoading={isLoading}
            loadingLabel={'Extracting'}
          />
        </Buttons>
      </div>
    </Modal>
  );
};

export default ManInvExtractModal;
